<template>
  <v-app>
    <v-app-bar
      absolute
      color="#ffffff"
      dark
      flat
      fixed
      :height="70"
      v-if="this.$route.fullPath != '/card' && this.$route.fullPath !='/pagebuilder'"
    >

      <v-toolbar-title @click="goTo('/')" style="cursor:pointer;">
        <img src="./assets/logo.jpeg" width="300" height="65" class="mt-5">
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text medium v-bind="attrs" v-on="on" color="#4527A0" @click="goTo('products')" class="d-none d-lg-flex d-xl-flex">
            <!-- <v-icon>mdi-home</v-icon> -->
            Products
          </v-btn>
        </template>
        <span>Products</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text medium v-bind="attrs" v-on="on" color="#4527A0" @click="goTo('about')" class="d-none d-lg-flex d-xl-flex">
            <!-- <v-icon>mdi-home</v-icon> -->
            About
          </v-btn>
        </template>
        <span>About</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text medium v-bind="attrs" v-on="on" color="#4527A0" @click="goTo('client')" class="d-none d-lg-flex d-xl-flex">
            <!-- <v-icon>mdi-phone</v-icon> -->
            Clients
          </v-btn>
        </template>
        <span>Clients</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text medium v-bind="attrs" v-on="on" color="#4527A0" @click="goTo('contact')" class="d-none d-lg-flex d-xl-flex">
            <!-- <v-icon>mdi-phone</v-icon> -->
            Contact
          </v-btn>
        </template>
        <span>Contact</span>
      </v-tooltip>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" color="#4527A0" class="d-md-none d-lg-none d-xl-none">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="goTo('/')">
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
          <v-list-item @click="goTo('/services')">
            <v-list-item-title>Services</v-list-item-title>
          </v-list-item>
          <v-list-item @click="goTo('/aboutus')">
            <v-list-item-title>About</v-list-item-title>
          </v-list-item>
          <v-list-item @click="goTo('/contactus')">
            <v-list-item-title>Contact</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <router-view></router-view>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
    
  },

  data: () => ({
    //
  }),
  methods:{
    goTo(path){
      let id = '#'+path;
      document.querySelector(id).scrollIntoView({behavior: 'smooth'});
    },
    getPath(){
      return this.$route.fullPath;
    }
  }
};
</script>
<style>
.toolbg{
  background: linear-gradient(90deg, rgba(221,181,245,1) 50%, rgba(245,195,237,1) 100%);
}
.mainbackcolor{
  background: linear-gradient(0deg, rgba(65,62,152,1) 0%, rgba(170,161,224,1) 100%);
}
.btns{
  background: linear-gradient(90deg, rgba(65,62,152,1) 64%, rgba(170,161,224,1) 100%);
  cursor: pointer;
}
.btns:hover{
  background: linear-gradient(90deg, rgba(170,161,224,1) 9%, rgba(65,62,152,1) 100%);
}
.bottomBorder{
  background: linear-gradient(90deg, rgba(65,62,152,1) 64%, rgba(170,161,224,1) 100%);
  width: 100px;
  height: 5px;
}
</style>